
import './AvatarGeneratorPage.css';
import React, { useState, useCallback } from 'react';
import AvatarEditor from './AvatarEditor';

function AvatarGeneratorPage() {
  const [currentSvg, setCurrentSvg] = useState('');
  const [currentOpts, setCurrentOpts] = useState({});

  const handleSvgChange = useCallback((svg, opts) => {
      setCurrentSvg(svg);
      setCurrentOpts(opts);
  }, []);

  const downloadSVG = () => {
    if (!currentSvg) return;
    const blob = new Blob([currentSvg], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'avatar.svg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadPNG = () => {
      if (!currentSvg) return;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      canvas.width = 500; 
      canvas.height = 500;

      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw CSS-like background if needed
        if (currentOpts.avatarStyle === 'Circle') {
             // Basic circle bg simulation for PNG
             ctx.beginPath();
             ctx.arc(250, 250, 250, 0, 2 * Math.PI);
             ctx.fillStyle = '#f1f5f9';
             ctx.fill();
        }

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const pngUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = pngUrl;
        link.download = 'avatar.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      
      // Handle base64 encoding safely
      img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(currentSvg)));
  };

  const ActionButtons = (
      <div style={{ display: 'flex', gap: '10px' }}>
          <button className="btn btn-secondary" style={{flex: 1}} onClick={downloadSVG}>
             SVG
          </button>
          <button className="btn btn-primary" style={{flex: 1}} onClick={downloadPNG}>
             PNG
          </button>
      </div>
  );

  return (
    <AvatarEditor 
        onSvgChange={handleSvgChange} 
        actionButtons={ActionButtons}
    />
  );
}

export default AvatarGeneratorPage;
